import { observable } from "mobx";
import Model from "~/models/Model";

class UiMeet3dEventNotification extends Model {
  /**
   * @property {number|null}
   */
  @observable id = null;

  @observable type = null;

  @observable recipient = null;

  @observable creationDts = null;

  @observable errorMessages = null;
}

export default UiMeet3dEventNotification;
